import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ProjectManagementService } from '../projects/project-management.service';
import { TodoCreateDialogComponent } from './todo-create-dialog/todo-create-dialog.component';
import { TodoDetailDialogComponent } from './todo-detail-dialog/todo-detail-dialog.component';
import { TodoService } from './todo.service';

@Component({
  selector: 'app-todo-page',
  templateUrl: './todo-page.component.html',
  styleUrls: ['./todo-page.component.scss']
})
export class TodoPageComponent implements OnInit {
  loading = false;
  tasks: any[] = [];
  todos: any[] = [];
  taskStatus = 'all';
  todoStatus = 'all';
  creating = false;

  constructor(
    private projectService: ProjectManagementService,
    private todoService: TodoService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    let remaining = 2;
    const finish = () => {
      remaining -= 1;
      if (remaining <= 0) this.loading = false;
    };

    this.projectService.getMyTasks({ status: this.taskStatus }).subscribe({
      next: (rows) => { this.tasks = rows || []; finish(); },
      error: () => { this.tasks = []; finish(); }
    });

    this.todoService.getMine(this.todoStatus).subscribe({
      next: (rows) => { this.todos = rows || []; finish(); },
      error: () => { this.todos = []; finish(); }
    });
  }

  openCreateTodo(): void {
    const dialogRef = this.dialog.open(TodoCreateDialogComponent, {
      width: '760px',
      maxWidth: '96vw',
      panelClass: 'app-modal-panel',
      backdropClass: 'app-modal-backdrop'
    });

    dialogRef.afterClosed().subscribe((payload) => {
      if (!payload) return;

      this.creating = true;
      this.todoService.create(payload).subscribe({
        next: () => {
          this.creating = false;
          this.load();
        },
        error: (err) => {
          this.creating = false;
          Swal.fire('Error', err?.error?.message || 'Failed to create todo.', 'error');
        }
      });
    });
  }

  openTask(row: any): void {
    this.openDialog('task', row);
  }

  openTodo(row: any): void {
    this.openDialog('todo', row);
  }

  private openDialog(type: 'task' | 'todo', item: any): void {
    const dialogRef = this.dialog.open(TodoDetailDialogComponent, {
      width: '900px',
      maxWidth: '96vw',
      panelClass: 'app-modal-panel',
      backdropClass: 'app-modal-backdrop',
      data: { type, item }
    });

    dialogRef.afterClosed().subscribe((changed) => {
      if (changed) this.load();
    });
  }
}
